import useDictateContext from '/druid/internal/useDictateContext';

export default function useSupported() {
  const { supported } = useDictateContext();

  return [supported];
}
